import { Col, Colors, IcCopy, IcEdit, IcMediaLibrary, IcTrash } from 'basic-ui-lib';
import PlaylistItemMobile from '../PlaylistItemMobile';
import { useNavigate } from 'react-router-dom';
import useGetListPlaylists from 'modules/playlist/services/hooks/useGetListPlaylists';
import SetToScreenMobile, { SetToScreenMobileRef } from '../SetToScreenMobile';
import { useRef, useState } from 'react';
import MenuActionMobile from 'basic-ui-lib/components/MenuActionMobile';
import { IPlaylist } from 'modules/playlist/interfaces/api';
import { ItemMenuProps } from 'basic-ui-lib/components/MenuActionMobile/ItemMenu';

interface PlaylistTableMobileProps {
  handleEditName: (item: IPlaylist) => void;
  handleDuplicate: (item: IPlaylist) => void;
  handleDelete: (playlistId: string) => void;
}

const PlaylistTableMobile = ({ handleEditName, handleDuplicate, handleDelete }: PlaylistTableMobileProps) => {
  const navigate = useNavigate();
  const [playlists] = useGetListPlaylists(true);
  const setToScreenModalRef = useRef<SetToScreenMobileRef>(null);
  const [selectedScreen, setSelectedScreen] = useState<IPlaylist | null>(null);
  const [open, setOpen] = useState(false);

  const listMenu = [
    {
      key: 'edit-name',
      title: 'Edit Name',
      icon: <IcEdit width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'edit-content',
      title: 'Edit Content',
      icon: <IcMediaLibrary width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'duplicate',
      title: 'Duplicate',
      icon: <IcCopy width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'delete',
      title: 'Delete',
      icon: <IcTrash width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
  ];

  const handleSelectPlaylist = (item: IPlaylist) => {
    setSelectedScreen(item);
    setOpen(true);
  };

  const handleMenuClick = (item: ItemMenuProps) => {
    if (!selectedScreen) return;

    switch (item.key) {
      case 'edit-name':
        handleEditName(selectedScreen);
        break;
      case 'edit-content':
        navigate(`/playlist/${selectedScreen.id}`);
        break;
      case 'duplicate':
        handleDuplicate(selectedScreen);
        break;
      case 'delete':
        handleDelete(selectedScreen.id);
        break;
      default:
        break;
    }
    setOpen(false);
  };

  return (
    <>
      <Col gap={0} flex={1} borderBottom='1px solid' borderColor={Colors.neutral.bg[5]}>
        {playlists?.content.map((item) => (
          <PlaylistItemMobile
            key={item.id}
            item={item}
            onClickSetToScreen={() => setToScreenModalRef.current?.open(item.id)}
            onClickMore={() => handleSelectPlaylist(item)}
          />
        ))}
      </Col>
      <SetToScreenMobile ref={setToScreenModalRef} />
      <MenuActionMobile listMenu={listMenu} open={open} onClose={() => setOpen(false)} onClickMenu={handleMenuClick} />
    </>
  );
};

export default PlaylistTableMobile;
